
import React from 'react';
import AnimatedSection from '../../../components/base/AnimatedSection';

const PainSection = () => {
  return (
    <AnimatedSection className="py-20 px-6 bg-gradient-to-br from-[#394851]/5 to-[#748881]/5">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-[#394851] mb-8">
          You didn't build a great business to watch it struggle in silence.
        </h2>
        
        <p className="text-xl text-[#748881] mb-12 leading-relaxed">
          You know your product works. Your service changes lives. But somehow, the right customers can't find you. 
          And you're starting to wonder if you made a terrible mistake.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-lg p-8 shadow-lg border-l-4 border-[#A8AE9C]">
            <div className="w-16 h-16 bg-[#394851]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-megaphone-line text-2xl text-[#394851]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#394851] mb-4">
              Your ads feel generic
            </h3>
            <p className="text-[#748881] leading-relaxed">
              You're spending money on marketing that sounds like everyone else. The words don't capture what makes you different. Customers scroll right past.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg border-l-4 border-[#A8AE9C]">
            <div className="w-16 h-16 bg-[#394851]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-building-line text-2xl text-[#394851]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#394851] mb-4">
              Big agencies don't get you
            </h3>
            <p className="text-[#748881] leading-relaxed">
              They see you as another invoice. They don't understand Main Street business. Their cookie-cutter approach makes you sound like everyone else.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg border-l-4 border-[#A8AE9C]">
            <div className="w-16 h-16 bg-[#394851]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-user-voice-line text-2xl text-[#394851]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#394851] mb-4">
              Word-of-mouth isn't enough
            </h3>
            <p className="text-[#748881] leading-relaxed">
              Your existing customers love you, but you can't scale on referrals alone. You need words that work as hard as you do to find new customers.
            </p>
          </div>
        </div>

        <div className="bg-[#394851] text-white rounded-lg p-8 max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold mb-4 text-[#A8AE9C]">
            Here's what's really happening:
          </h3>
          <p className="text-lg leading-relaxed mb-4">
            Your words don't reflect your reality. You've built something great, but the language around it makes you invisible to the people who need you most.
          </p>
          <p className="text-lg leading-relaxed text-gray-300">
            This isn't a business problem—<strong className="text-[#A8AE9C]">it's a words problem</strong>. And words problems have words solutions.
          </p>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default PainSection;
